<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" @click="goBack" />
    </div>

    <header class="header">
      <div>
        <h1>Nuevo reporte de falla</h1>
        <p class="sub">Captura la falla mecanica y registra la unidad afectada.</p>
      </div>
      <button class="btn btn--ghost" @click="goBack">Regresar</button>
    </header>

    <section class="card">
      <div class="form-grid">
        <label class="field">
          <span>Fecha de solicitud</span>
          <input :value="requestTimePreview" type="text" disabled />
          <small class="hint">Se registra automaticamente al guardar.</small>
        </label>

        <label class="field">
          <span>Fecha y hora de observacion</span>
          <input v-model="form.observation_tiem" type="datetime-local" />
        </label>

        <label class="field">
          <span>Unidad</span>
          <select v-model="form.unit">
            <option disabled value="">Selecciona una unidad</option>
            <option v-for="unit in units" :key="unit.id" :value="unit.id">
              {{ unit.unit_short_id }} - {{ unit.unit_plates || 'SIN PLACAS' }}
            </option>
          </select>
        </label>

        <label class="field">
          <span>Sistema</span>
          <input v-model="form.system" type="text" maxlength="100" placeholder="Ej. Frenos, motor, electrico" />
        </label>

        <label class="field field--full">
          <span>Descripcion</span>
          <textarea v-model="form.description" rows="6" maxlength="10000"></textarea>
        </label>
      </div>

      <div class="actions">
        <button class="btn btn--ghost" @click="setNow">Usar hora actual</button>
        <button class="btn btn--primary" :disabled="saving" @click="submitReport">
          {{ saving ? 'Guardando...' : 'Crear reporte' }}
        </button>
      </div>

      <p v-if="error" class="error">{{ error }}</p>
      <p v-if="success" class="success">{{ success }}</p>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NewUnitMalfunctionReport',
  data() {
    return {
      permissions: [],
      units: [],
      saving: false,
      error: '',
      success: '',
      requestTimePreview: '',
      form: {
        observation_tiem: '',
        unit: '',
        system: '',
        description: '',
      },
    }
  },
  created() {
    this.setNow()
    this.fetchCurrentUser()
    this.fetchUnits()
  },
  methods: {
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    setNow() {
      const now = new Date()
      now.setSeconds(0, 0)
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hour = String(now.getHours()).padStart(2, '0')
      const minute = String(now.getMinutes()).padStart(2, '0')
      this.form.observation_tiem = `${year}-${month}-${day}T${hour}:${minute}`
      this.requestTimePreview = now.toLocaleString('es-MX')
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        if (!this.hasPerm('maintenance.create_incident')) {
          this.$router.push({ path: '/maintenance/malfunction-reports' })
        }
      } catch (error) {
        this.$router.push({ path: '/maintenance/malfunction-reports' })
      }
    },
    async fetchUnits() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/unit-malfunction-reports/units`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.units = Array.isArray(data) ? data : []
      } catch (error) {
        this.error = 'No se pudieron cargar las unidades.'
      }
    },
    validateForm() {
      if (!this.form.observation_tiem) return 'La fecha de observacion es obligatoria.'
      if (!this.form.unit) return 'Selecciona una unidad.'
      if (!this.form.system.trim()) return 'El sistema es obligatorio.'
      if (!this.form.description.trim()) return 'La descripcion es obligatoria.'
      return ''
    },
    async submitReport() {
      this.error = ''
      this.success = ''
      const validationError = this.validateForm()
      if (validationError) {
        this.error = validationError
        return
      }
      const apiDirectory = process.env.API_DIRECTORY
      this.saving = true
      try {
        await axios.post(
          `${apiDirectory}/unit-malfunction-reports`,
          {
            observation_tiem: new Date(this.form.observation_tiem).toISOString(),
            unit: this.form.unit,
            system: this.form.system.trim(),
            description: this.form.description.trim(),
          },
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        )
        this.success = 'Reporte creado correctamente.'
        this.form.unit = ''
        this.form.system = ''
        this.form.description = ''
        this.setNow()
      } catch (error) {
        this.error = error?.response?.data?.error || 'No se pudo crear el reporte.'
      } finally {
        this.saving = false
      }
    },
    goBack() {
      this.$router.push({ path: '/maintenance/malfunction-reports' })
    },
  },
}
</script>

<style scoped>
.main-panel { min-height: 100vh; background: #f3f6fd; padding: 12vh 24px 48px; }
.nav-bar-operations { position: absolute; top: 0; left: 0; width: 100vw; height: 10vh; background: #ffc434; display: flex; align-items: center; padding-left: 16px; }
.logo-button { height: 55%; object-fit: contain; cursor: pointer; }
.header { margin-top: 10px; margin-bottom: 12px; display: flex; justify-content: space-between; gap: 12px; align-items: center; background: rgba(255, 255, 255, 0.78); border: 1px solid rgba(15, 23, 42, 0.08); border-radius: 16px; padding: 12px 16px; }
.header h1 { margin: 0; font-size: 1.2rem; color: #0f172a; }
.sub { margin: 3px 0 0; color: #667085; }
.card { background: #fff; border: 1px solid #e5e7eb; border-radius: 16px; padding: 16px; max-width: 980px; margin: 0 auto; box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08); }
.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
.field { display: grid; gap: 6px; }
.field span { font-size: 0.95rem; font-weight: 600; color: #344054; }
.field input, .field select, .field textarea { border: 1px solid #d0d7de; border-radius: 10px; padding: 9px 10px; font: inherit; }
.field--full { grid-column: 1 / -1; }
.hint { color: #667085; font-size: .78rem; }
.actions { display: flex; justify-content: space-between; margin-top: 12px; }
.btn { border-radius: 10px; padding: 9px 12px; border: 1px solid transparent; cursor: pointer; }
.btn--ghost { background: #fff; border-color: #d0d7de; }
.btn--primary { background: #2563eb; color: #fff; }
.error { color: #b42318; margin-top: 8px; }
.success { color: #166534; margin-top: 8px; }
@media (max-width: 900px) {
  .form-grid { grid-template-columns: 1fr; }
}
</style>
